<div mat-dialog-title>
  {{ 'Contacts.Download.Title' | translate : locale.language}}
</div>

<div class="dialog-container">
  <div mat-dialog-content>
    <mat-checkbox *ngIf="(hasError$ | async) === false" [disabled]="isDownloading$ | async" [(ngModel)]="includeMemberships"
      [matTooltip]="'Contacts.Download.IncludeGroupsTooltip' | translate : locale.language">
      {{ 'Contacts.Download.IncludeGroups' | translate : locale.language}}
    </mat-checkbox>

    <app-loading [hasFailed]="hasError$ | async" [hasLoaded]="(isDownloading$ | async) === false"
      (retryClicked)="onDownload()" [isCircle]="false" [alignCenter]="true"
      style="text-align:center"></app-loading>
  </div>
</div>

<div class="right" mat-dialog-actions>
  <button mat-button mat-dialog-close>
    {{ 'Cancel' | translate : locale.language}}
  </button>
  <button mat-raised-button color="primary" [disabled]="(hasError$ | async) || (isDownloading$ | async)" (click)="onDownload()">
    {{ 'Contacts.Download.BeginExport' | translate : locale.language}}
  </button>
</div>